export const DOCUMENT_AUTHORING_TAGS = {
  AUTHORING_DOCUMENT_TAG: "AuthoringDocument",
  AUTHORING_RUN_TAG: "AuthoringRun",
};

export const DOCUMENT_AUTHORING_BASE_URL = "/pf-mainweb/document-authoring";

/** Suffix the backend appends when a user has no explicit AI author name. */
export const AI_AUTHOR_SUFFIX = "(Pathfinder)";

export const DOCX_MIME_TYPE = "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
